// extracted by mini-css-extract-plugin
export default {"container":"AM-z","modal":"BM-z","dimensions":"CM-z","brandName":"DM-z","productName":"EM-z","labelValue":"FM-z","recipientEmail":"GM-z","recommendedFit":"HM-z","hiddenField":"IM-z"};